
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"--vk-bg-color":"#484F67"},style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg","style":"--vk-bg-color:#484F67"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.5 4.5a3 3 0 00-3-3h-15a3 3 0 00-3 3v15a3 3 0 003 3h15a3 3 0 003-3v-15z","fill":"var(--vk-bg-color)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.937 13.511c.334 0 .78.057 1.268.278.562.255 1.188.746 1.77 1.534.18.243.469.75.618 1.012.06.101.17.165.285.165h1.8a.284.284 0 00.259-.405l-.303-.656c-.784-1.583-1.703-2.565-2.588-3.18.593-.488 1.196-1.17 1.766-2.127a8.35 8.35 0 00.848-1.908.283.283 0 00-.274-.349h-1.703a.369.369 0 00-.33.206l-.116.233c-.746 1.507-1.556 2.284-2.302 2.64-.386.183-.735.24-1.005.247V8.254a.371.371 0 00-.375-.375h-1.5a.371.371 0 00-.375.375V14.1c-2.112-.893-3.195-3.094-3.188-5.092v-.75a.376.376 0 00-.375-.375c-.416 0-1.084 0-1.5-.004a.374.374 0 00-.375.375v.75c-.011 3.364 2.243 7.368 6.375 7.504h.938a.376.376 0 00.375-.375v-2.614l.007-.008z","fill":"#fff"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/img/VK.svg